import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "h3" }, "Dane osobowe", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 lg:mb-8 Texte" }, "Uzupełnij dane klienta.", -1)
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-5" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-5" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-5" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-5" }

import NameField from './Fields/PatientData/NameField.vue';
import SurnameField from './Fields/PatientData/SurnameField.vue';
import EmailField from './Fields/PatientData/EmailField.vue';
import PhoneField from './Fields/PatientData/PhoneField.vue';
import AddressField from './Fields/PatientData/AddressField.vue';
import CityField from './Fields/PatientData/CityField.vue';
import ZipCodeField from './Fields/PatientData/ZipCodeField.vue';
import PeselField from './Fields/PatientData/PeselField.vue';
import HomeNumberField from './Fields/PatientData/HomeNumberField.vue';

export default {
  __name: 'PatientData',
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(NameField),
      _createVNode(SurnameField)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(EmailField),
      _createVNode(PhoneField)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AddressField),
      _createVNode(HomeNumberField)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(CityField),
      _createVNode(ZipCodeField)
    ])
  ]))
}
}

}